// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
/**
 * Thread read status filters.
 * These correlate to the OR filters in the threads list header.
 */
export var ThreadReadStatus;
(function (ThreadReadStatus) {
    ThreadReadStatus["READ"] = "READ";
    ThreadReadStatus["NEW"] = "NEW";
    ThreadReadStatus["ERROR"] = "ERROR";
    ThreadReadStatus["REPLIED"] = "REPLIED";
    ThreadReadStatus["UNREPLIED"] = "UNREPLIED";
})(ThreadReadStatus || (ThreadReadStatus = {}));
export var ThreadReadStatus_index;
(function (ThreadReadStatus_index) {
    ThreadReadStatus_index[ThreadReadStatus_index["READ"] = 0] = "READ";
    ThreadReadStatus_index[ThreadReadStatus_index["NEW"] = 1] = "NEW";
    ThreadReadStatus_index[ThreadReadStatus_index["ERROR"] = 2] = "ERROR";
    ThreadReadStatus_index[ThreadReadStatus_index["REPLIED"] = 3] = "REPLIED";
    ThreadReadStatus_index[ThreadReadStatus_index["UNREPLIED"] = 4] = "UNREPLIED";
})(ThreadReadStatus_index || (ThreadReadStatus_index = {}));
/**
 * A InboxView represents a logical tab in the inbox.
 */
export var InboxView;
(function (InboxView) {
    InboxView["UNSPECIFIED"] = "UNSPECIFIED";
    InboxView["ARCHIVED"] = "ARCHIVED";
    InboxView["ACTIONABLE"] = "ACTIONABLE";
    InboxView["BLOCKED"] = "BLOCKED";
})(InboxView || (InboxView = {}));
export var InboxView_index;
(function (InboxView_index) {
    InboxView_index[InboxView_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    InboxView_index[InboxView_index["ARCHIVED"] = 1] = "ARCHIVED";
    InboxView_index[InboxView_index["ACTIONABLE"] = 2] = "ACTIONABLE";
    InboxView_index[InboxView_index["BLOCKED"] = 3] = "BLOCKED";
})(InboxView_index || (InboxView_index = {}));
export const SMSService = {
    /**
     * Get thread along with page of messages with pagination support.
     */
    GetThread(fn, req) {
        try {
            fm.validateUrlParam(req["threadId"], "threadId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/sms/data/v4/threads/${req["threadId"]}?${fm.renderURLSearchParams(req, ["threadId"])}`, { method: "GET" });
    },
    /**
     * Get full thread details with only the most recent message included.
     */
    GetThreadDetails(fn, req) {
        try {
            fm.validateUrlParam(req["threadId"], "threadId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/sms/data/v4/threads/${req["threadId"]}:details?${fm.renderURLSearchParams(req, ["threadId"])}`, { method: "GET" });
    },
    /**
     * Lists threads with pagination support.
     */
    ListThreads(fn, req) {
        return fn(`/sms/data/v4/threads?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Fetches total counts of threads based on filter criteria.
     */
    CountThreads(fn, req) {
        return fn(`/sms/data/v4/threads:count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Given locationId, locationPhone, and personPhone, returns the thread ID.
     */
    GetThreadId(fn, req) {
        return fn(`/sms/data/v4/thread-id?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
